import React, { useRef, useState, useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import emailjs from 'emailjs-com';

export default function Contato() {
  const form = useRef();
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setErro(false);
    setEnviado(false);

    emailjs.sendForm(
      'service_srxt2q5',      
      'template_cjc40zj',     
      form.current,
      'bh4OGgSROB3mThaaw'          
    )
    .then(() => {
      setEnviado(true);
      form.current.reset();
    }, () => {
      setErro(true);
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      
      <main className="flex-grow">
        
        {/* BANNER DE CONTATO REFORMULADO PARA PREENCHER O VAZIO */}
        <section className="relative bg-usifresa-blue text-white py-20 lg:py-32 overflow-hidden">
          
          {/* Fundo sutil da fábrica para dar textura ao lado direito */}
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <img src="/fachada.jpeg" alt="Fábrica Usifresa" className="w-full h-full object-cover" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-usifresa-blue via-usifresa-blue/90 to-usifresa-blue/40"></div>

          <div className="container mx-auto px-6 md:px-12 relative z-10">
            <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
              
              {/* Lado Esquerdo - Textos e Títulos */}
              <div className="flex-1 w-full lg:max-w-xl">
                
                {/* Tag de Engenharia */}
                <div className="flex items-center gap-4 mb-6 pt-10">
                  <span className="w-12 h-[3px] bg-usifresa-orange"></span>
                  <span className="text-xs md:text-sm font-black text-usifresa-light-blue uppercase tracking-[0.3em]">
                    Atendimento
                  </span>
                </div>
                
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-sans font-black mb-6">Contato</h1>
                
                {/* Linha Laranja (w-full acompanhando o texto) */}
                <div className="h-1 bg-usifresa-orange mb-8 w-full animate-[linhaGrow_2s_ease-out_forwards]"></div>
                
                <p className="text-lg text-gray-300 leading-relaxed">
                  Entre em contato conosco para obter mais informações, solicitar orçamentos ou esclarecer dúvidas. Estamos prontos para atendê-lo e fornecer assistência personalizada.
                </p>
              </div>

              {/* Lado Direito - Cards de Contato (Preenchendo o Vazio) */}
              <div className="flex-1 w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
                
                {/* Card de Telefone */}
                <a href="tel:+551639872253" className="group bg-white/5 backdrop-blur-md border border-white/10 p-6 md:p-8 rounded-3xl hover:bg-white/10 hover:border-white/20 transition-all duration-300 shadow-xl">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-usifresa-light-blue mb-4 group-hover:scale-110 transition-transform duration-300" fill="currentColor" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
                  </svg>
                  <h2 className="font-bold text-base uppercase tracking-wider text-white mb-1">Telefone</h2>
                  <p className="text-gray-300 text-sm md:text-base group-hover:text-white transition-colors">(16) 3987-2253</p>
                </a>

                {/* Card de E-mail */}
                <a href="mailto:usifresa@usifresa.com.br" className="group bg-white/5 backdrop-blur-md border border-white/10 p-6 md:p-8 rounded-3xl hover:bg-white/10 hover:border-white/20 transition-all duration-300 shadow-xl">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-usifresa-light-blue mb-4 group-hover:scale-110 transition-transform duration-300" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"/>
                  </svg>
                  <h2 className="font-bold text-base uppercase tracking-wider text-white mb-1">E-mail</h2>
                  <p className="text-gray-300 text-sm md:text-base break-all group-hover:text-white transition-colors">usifresa@usifresa.com.br</p>
                </a>

                {/* Card de Endereço (Ocupando 2 colunas para fechar o grid perfeitamente) */}
                <div className="group bg-white/5 backdrop-blur-md border border-white/10 p-6 md:p-8 rounded-3xl transition-all duration-300 sm:col-span-2 shadow-xl hover:bg-white/10 hover:border-white/20 cursor-default">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-usifresa-light-blue mb-4 group-hover:scale-110 transition-transform duration-300" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
                  </svg>
                  <h2 className="font-bold text-base uppercase tracking-wider text-white mb-1">Localização</h2>
                  <p className="text-gray-300 text-sm md:text-base group-hover:text-white transition-colors">
                    R. Antonio Cavalheiro Sobrinho, 339 - Distrito Industrial II<br className="hidden sm:block" />
                    Serrana - SP, 14150-000
                  </p>
                </div>

              </div>

            </div>
          </div>
        </section>

        {/* RESTO DA PÁGINA (Formulário, Mapa e Redes Sociais) */}
        <section className="container mx-auto px-6 md:px-12 py-16">
          <div className="flex flex-col lg:flex-row gap-16">
            
            <div className="flex-1 bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-gray-100">
              <h2 className="text-3xl font-bold text-usifresa-blue mb-4">Envie uma mensagem</h2>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Preencha o formulário abaixo para nos enviar suas dúvidas, comentários ou solicitações. Estamos ansiosos para ouvir de você e responder prontamente.
              </p>
              
              <form ref={form} onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">Nome</label>
                    <input type="text" id="nome" name="nome" placeholder="Seu nome" required className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-usifresa-light-blue focus:border-usifresa-light-blue outline-none transition-shadow" />
                  </div>
                  <div>
                    <label htmlFor="sobrenome" className="block text-sm font-medium text-gray-700 mb-2">Sobrenome</label>
                    <input type="text" id="sobrenome" name="sobrenome" placeholder="Seu sobrenome" className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-usifresa-light-blue focus:border-usifresa-light-blue outline-none transition-shadow" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">E-mail</label>
                    <input type="email" id="email" name="email" placeholder="seu@email.com" required className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-usifresa-light-blue focus:border-usifresa-light-blue outline-none transition-shadow" />
                  </div>
                  <div>
                    <label htmlFor="telefone" className="block text-sm font-medium text-gray-700 mb-2">Telefone</label>
                    <input type="tel" id="telefone" name="telefone" placeholder="(00) 00000-0000" className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-usifresa-light-blue focus:border-usifresa-light-blue outline-none transition-shadow" />
                  </div>
                </div>
                <div>
                  <label htmlFor="assunto" className="block text-sm font-medium text-gray-700 mb-2">Assunto</label>
                  <input type="text" id="assunto" name="assunto" placeholder="Assunto da mensagem" required className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-usifresa-light-blue focus:border-usifresa-light-blue outline-none transition-shadow" />
                </div>
                <div>
                  <label htmlFor="mensagem" className="block text-sm font-medium text-gray-700 mb-2">Mensagem</label>
                  <textarea id="mensagem" name="mensagem" placeholder="Sua mensagem..." rows={5} required className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-usifresa-light-blue focus:border-usifresa-light-blue outline-none transition-shadow resize-none"></textarea>
                </div>
                <button type="submit" className="w-full py-4 bg-usifresa-blue hover:bg-[#0a3861] text-white font-bold rounded-xl shadow-lg transition-colors">
                  Enviar mensagem
                </button>
                
                {enviado && <div className="p-4 bg-green-50 text-green-700 rounded-xl border border-green-200">Mensagem enviada com sucesso!</div>}
                {erro && <div className="p-4 bg-red-50 text-red-700 rounded-xl border border-red-200">Erro ao enviar. Tente novamente.</div>}
              </form>
            </div>

            <div className="flex-1 flex flex-col gap-8">
              <div className="bg-white p-4 rounded-3xl shadow-xl border border-gray-100 overflow-hidden h-[400px]">
                <iframe 
                  className="w-full h-full rounded-2xl" 
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d476161.45111043006!2d-48.2044925!3d-21.1917086!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94b9dac8446976ab%3A0x999c8c442fa069ac!2sUsifresa%20Ind.%20Con.%20de%20Maquinas%20e%20Equipamentos!5e0!3m2!1spt-BR!2sbr!4v1754607435901!5m2!1spt-BR!2sbr" 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa Usifresa"
                ></iframe>
              </div>

              <div className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border border-gray-100 flex-grow flex flex-col justify-center relative overflow-hidden">
                <div className="absolute -top-20 -right-20 w-48 h-48 bg-usifresa-light-blue/10 rounded-full blur-3xl pointer-events-none"></div>
                
                <div className="relative z-10">
                  <h2 className="text-2xl font-bold text-usifresa-blue mb-4">Siga nas redes sociais</h2>
                  <p className="text-gray-600 mb-8 leading-relaxed">
                    Acompanhe nossos lançamentos, bastidores da fábrica e novidades do setor através de nossos canais oficiais.
                  </p>
                  
                  <div className="flex flex-col sm:flex-row gap-4">
                    <a 
                      href="https://facebook.com/usifresa" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="flex-1 flex items-center justify-center gap-3 py-4 px-6 rounded-2xl bg-[#1877F2]/10 hover:bg-[#1877F2] text-[#1877F2] hover:text-white font-bold transition-colors border border-[#1877F2]/20 hover:border-[#1877F2]"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 fill-current" viewBox="0 0 16 16"><path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/></svg>
                      Facebook
                    </a>
                    
                    <a 
                      href="https://instagram.com/usifresaoficial" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="flex-1 flex items-center justify-center gap-3 py-4 px-6 rounded-2xl bg-[#E1306C]/10 hover:bg-[#E1306C] text-[#E1306C] hover:text-white font-bold transition-colors border border-[#E1306C]/20 hover:border-[#E1306C]"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 fill-current" viewBox="0 0 16 16"><path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/></svg>
                      Instagram
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}